module.exports = __webpack_public_path__ + "1ea226c814fe150b5d454c5bf7a3cfc5.gif";